module.exports = __webpack_public_path__ + "media/recipes/default-5c07bb9f.png";